export const GMAIL_LABELS = [
  "INBOX",
  "SPAM",
  "TRASH",
  "UNREAD",
  "STARRED",
  "IMPORTANT",
  "SENT",
  "DRAFT",
  "CATEGORY_PERSONAL",
  "CATEGORY_SOCIAL",
  "CATEGORY_PROMOTIONS",
  "CATEGORY_UPDATES",
  "CATEGORY_FORUMS",
];

export const customValuesQuery = [
  {
    triggerName: "gmailReceived",
    propertyName: "labels",
  },
];

export const generateDummyQueryBuilderResponse = (values: string[]) => {
  return {
    status: 200,
    data: values.map((value) => {
      return {
        id: value,
        name: value,
      };
    }),
  };
};

/** Trigger event IDs that require custom handling in the QB pipeline */
export enum SpecialTrigger {
  WhatsAppCart = "whatsAppCart",
  FormSubmitted = "formSubmitted",
}

/** Property name IDs exposed for the formSubmitted trigger */
export enum FormSubmittedProperty {
  FormId = "formId",
  FormName = "formName",
}

/** Sub-header group keys used when categorising formSubmitted variables */
export enum FormSubmittedVarGroup {
  Basic = "Basic",
  Recommendations = "Recommendations",
}
